import { axiosInstance } from "../../../axios/axiosInstance";

const API_COUPON_CODES_URL = "admin/coupon_code";
const API_COUPON_CODE_MODULE_LIST_URL = API_COUPON_CODES_URL + "/list";
const API_CREATE_COUPON_CODE_MODULE_URL = API_COUPON_CODES_URL + "/create";
const API_GET_COUPON_CODE_BY_ID_URL = API_COUPON_CODES_URL + "/view";
const API_UPDATE_COUPON_CODE_BY_ID_URL = API_COUPON_CODES_URL + "/update";
const API_DELETE_COUPON_CODE_MODULE_URL =
  API_COUPON_CODES_URL + "/update-status";

export const getCouponCodes = () => {
  return axiosInstance.get(API_COUPON_CODE_MODULE_LIST_URL);
};

export const createCouponCode = (dataToBeSent) => {
  return axiosInstance.post(API_CREATE_COUPON_CODE_MODULE_URL, dataToBeSent);
};

export const getCouponCodeById = (dataToBeSent) => {
  return axiosInstance.get(
    API_GET_COUPON_CODE_BY_ID_URL + "/" + dataToBeSent?.selectedCouponCodeId
  );
};

export const updateCouponCode = (dataToBeSent) => {
  return axiosInstance.post(
    API_UPDATE_COUPON_CODE_BY_ID_URL + "/" + dataToBeSent?._id,
    dataToBeSent
  );
};

export const deleteCouponCodeById = (dataToBeSent) => {
  return axiosInstance.patch(
    API_DELETE_COUPON_CODE_MODULE_URL +
      "/" +
      dataToBeSent?.selectedCouponCodeId,
    {
      is_active: false,
    }
  );
};
